import { mapActions, mapGetters } from 'vuex';
import fbIcon from '@/assets/icons/footer/old/facebook.svg';
import instaIcon from '@/assets/icons/footer/old/instagram.svg';
import twitterIcon from '@/assets/icons/footer/old/x.svg';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  data() {
    return {
      debugClickCount: 0,
      debugClickThreshold: 7,
      debugClickTimer: null,
      items: [
        { title: 'Facebook', href: process.env.PI_FACEBOOK_LINK, icon: fbIcon },
        { title: 'Instagram', href: process.env.PI_INSTAGRAM_LINK, icon: instaIcon },
        { title: 'x', href: process.env.PI_TWITTER_LINK, icon: twitterIcon },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['isUserRestricted']),
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    handleSecretTap() {
      this.debugClickCount += 1;
      clearTimeout(this.debugClickTimer);
      this.debugClickTimer = setTimeout(() => {
        this.debugClickCount = 0;
      }, 2000);

      if (this.debugClickCount >= this.debugClickThreshold) {
        this.debugClickCount = 0;
        this.$router.push({ name: 'user-status' });
      }
    },
    onLearnMore() {
      this.setCurrentPopup(MODALS.RESEARCH);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-footer/app-footer.js